<mat-dialog-content class="mat-typography">
  <h2>Você realmente deseja excluir este usuário?</h2>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Sim</button>
</mat-dialog-actions>
